/*
* Global add to cart 
*
*/
var glbAddToCart = function(variantid, qty){ 
      
        if(variantid !==null ){
            
            var postAdddata = {
                "quantity":qty,
                "id": variantid
            }
            let curQty = $(".cart-count .cart-num").text()?parseInt($(".cart-count .cart-num").text()):0;
            $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/add.js',
                data: postAdddata,
                dataType: 'json',
                success: function(addeddata) { 
                    if(!$(document.body).hasClass("template-cart")){
                        $("#mini-cart-icon").addClass("has-items")
                        let finalQty = curQty + qty;
                        $(".cart-count .cart-num").text(finalQty);
                        $(".mini-cart-num").text(finalQty);
                        if(document.querySelector("#mini-cart-icon")!==null){
                            document.querySelector("#mini-cart-icon").click()
                        }
                        console.error(addeddata);
                    }else{
                        location.reload()
                    }
                    
                },
                error: function(xhr, status, error){
                    console.error('Error:', xhr.responseJSON.description);
               
                }
             });

        }else{
            var messageValidation = theme.strings.selectSize;
            return messageValidation;
            
        }
    }

/**
 * Global Quick view display
 * 
 */

var glbQuickView = function(handle){
checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
    glbDisplayQuickview(handle);
});
}  

var glbDisplayQuickview = function(handle){
        var _THIS = $(this);
        $.fancybox.close("true");

        _THIS.popupInstance  =  $.fancybox.open('<div id="quickview-product-template" class="layout-quickview"><div class="wrap-content"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div>',{
            afterShow : function( instance, current ) {
    
                glbQuickviewHTML(handle,function(qhtml){
                 
                        
                       
                        (async () => {
                            const { default:models } = await import(theme.components.modelsURL);

                            $("#quickview-product-template .wrap-content").html(qhtml)
                            models.updateQuickViewModelsDisplay();
                             

                            var instProduct = new product();
                            instProduct.init("#quickview-product-template")

                            
                        
                        })();
                        
                        
                    
                    //Update the product link
                    //$("#quickview-product-template .full-details a").attr("href",producturl)
                    
                });
            }	
        });
    }

    var glbQuickviewHTML = function(phandle,callback){ 
        $.ajax({
            type: 'GET',
            url:window.Shopify.routes.root + 'products/' + phandle + '?view=quickview',
            success: function(response) {
                if(callback != null) return callback.call(this,response);
            },
            error: function(status) {
                console.warn( 'ERROR', status );
            }
        })
    }


    function checkLibrary(library, libraryurl, callback){

        if(typeof(library)=="undefined"){ // we do not load fancy lib on page load but on quickview link (if lib not loaded yet)
                              
            const script = document.createElement('script');
            script.src = libraryurl;
    
            // Append to the `head` element
            document.head.appendChild(script);
            script.addEventListener('load', function() {
                if(callback != null) return callback.call(this);
            });
        }else{
            if(callback != null) return callback.call(this);
        }
    
    }

